import { render } from "./PosCart.vue?vue&type=template&id=2695638c&scoped=true"
import script from "./PosCart.vue?vue&type=script&lang=js"
export * from "./PosCart.vue?vue&type=script&lang=js"

import "./PosCart.vue?vue&type=style&index=0&id=2695638c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2695638c"]])

export default __exports__